<ng-container *transloco="let transloco">
  <div class="m-0 flex min-h-screen w-full flex-col lg:grid lg:h-screen lg:grid-cols-[620px_1fr]">

    <nsf-auth-aside
      class="hidden lg:block"
      [eyebrow]="transloco('AUTH.BRAND.EYEBROW')"
      [title]="transloco('ERROR_PAGE.ASIDE_TITLE', { variant: variant() })"
      [subtitle]="transloco('ERROR_PAGE.ASIDE_SUBTITLE', { variant: variant() })">
    </nsf-auth-aside>

    <div class="flex flex-1 flex-col items-center justify-center gap-10 bg-surface px-6 py-12 lg:px-14 lg:py-10">

      <div class="flex w-full max-w-[440px] flex-col gap-8 md:max-w-[460px] lg:max-w-[440px]">

        <!-- Header -->
        <div class="flex flex-col gap-[22px]">
          <div aria-hidden="true" class="flex items-center gap-3 lg:gap-3.5">
            <img src="/assets/img/nsa-logo.svg" alt="" class="h-9 w-auto lg:h-11">
            <span aria-hidden="true" class="h-[26px] w-px bg-line lg:h-[30px]"></span>
            <span class="text-xl font-bold text-ink-2 lg:text-[22px]">nservices</span>
          </div>
          <div class="flex flex-col gap-3">
            <p class="m-0 text-xs font-extrabold tracking-[0.18em] text-ink-3">
              {{ transloco('ERROR_PAGE.EYEBROW', { variant: variant() }) | uppercase }}
            </p>
            <h1 class="m-0 text-[26px] font-extrabold leading-[1.25] text-ink lg:text-[30px]">
              {{ transloco('ERROR_PAGE.TITLE', { variant: variant() }) }}
            </h1>
            <p class="m-0 text-[15px] leading-[1.6] text-ink-3">
              {{ transloco('ERROR_PAGE.DESCRIPTION', { variant: variant() }) }}
            </p>
          </div>
        </div>

        @if(isForbidden() && !!user()) {
          <div class="flex gap-2.5 rounded-lg border border-line bg-surface-2 p-4">
            <span class="material-symbols-outlined icon-sm shrink-0 pt-px text-ink-3" aria-hidden="true">person</span>
            <p class="m-0 text-[13px] leading-[1.55] text-ink-2" [innerHtml]="transloco('ERROR_PAGE.FORBIDDEN.SESSION', { email: user()?.email, role: user()?.role?.name })"></p>
          </div>
        }

        <div class="flex flex-col gap-3">
          @if(isNotFound()) {
            <nsa-button nsaId="error-back" type="button" size="lg" className="w-full" icon="arrow_back" (click)="onBack()">
              {{ transloco('ERROR_PAGE.NOT_FOUND.BACK') }}
            </nsa-button>
            <nsa-button nsaId="error-dashboard" type="button" size="lg" color="secondary" outlined className="w-full" (click)="onDashboard()">
              {{ transloco('ERROR_PAGE.NOT_FOUND.DASHBOARD') }}
            </nsa-button>
            <p class="m-0 pt-2 text-[13px] leading-[1.6] text-ink-3">
              {{ transloco('ERROR_PAGE.NOT_FOUND.SUPPORT') }}
              <a class="font-bold no-underline" [href]="supportUrl()">{{ transloco('ERROR_PAGE.NOT_FOUND.SUPPORT_LINK', { email: supportEmail() }) }}</a>
            </p>
          } @else if(isForbidden()) {
            <nsa-button nsaId="error-request-access" type="button" size="lg" className="w-full" (click)="onRequestAccess()">
              {{ transloco('ERROR_PAGE.FORBIDDEN.REQUEST_ACCESS', { email: supportEmail() }) }}
            </nsa-button>
            @if(!!user()) {
              <nsa-button nsaId="error-dashboard" type="button" size="lg" color="secondary" outlined className="w-full" (click)="onDashboard()">
                {{ transloco('ERROR_PAGE.FORBIDDEN.DASHBOARD') }}
              </nsa-button>
            } @else {
              <nsa-button nsaId="error-login" type="button" size="lg" color="secondary" outlined className="w-full" (click)="onLogin()">
                {{ transloco('ERROR_PAGE.FORBIDDEN.LOGIN') }}
              </nsa-button>
            }
          }
        </div>

      </div>

    </div>

  </div>
</ng-container>